<app-header class="w-100 float-start fixed-header" [ngClass]="showHeaderFooter? '': 'd-none'"></app-header>

<div class="position-absolute d-flex pt-4 message font-sm">
  <div role="status" [ngClass]="showErrorLabel? 'd-block': 'd-none'">
    <label>{{message}}</label>
  </div>

  <div role="status" [ngClass]="showSignInError? 'd-block': 'd-none'">
    <label>{{message}}</label>
  </div>
</div>
<section (window:beforeunload)="doBeforeUnload()" (window:mouseover)="doMouseOver()" (window:mouseout)="doMouseOut()"
  class="" [ngClass]="router.url !== '/logout' ? 'ms-3 me-3 mt-57' : ''">
  <ngx-idle-timeout *ngIf="idleTimer" [allowedIdleTimeInSeconds]="appConfig.settings.defaults.SessionTimeOut"
    [message]="'You will be logged out in: '" [warningTimeInSeconds]="appConfig.settings.defaults.WarningTimeOut">
  </ngx-idle-timeout>
  <router-outlet>
  </router-outlet>
</section>
<app-confirm-box [showApprovalPopUp]="showLoginPopUp" [timerCount]="timeleft"
  (sessionOverTakeApprovalStatus)=sessionOverTakeApprovalStatus($event)></app-confirm-box>
<app-footer [ngClass]="showHeaderFooter? '': 'd-none'" class="w-100 float-start px-4 pt-1 font-md"></app-footer>

<ng-container>

  <div class="container-fluid position-absolute top-0 start-0 overflow-hidden">
    <div class="row justify-content-center">
      <div class="col-12 p-0">
        <div class="wrap d-md-flex" *ngIf="checksDone === false">
          <div class="text-wrap p-4 p-lg-5 col-sm-12 col-md-6">
          </div>
          <div class="login-wrap p-4 p-lg-5 col-sm-12 col-md-6">
            <div class=" h-100 bg-serverbox" role="dialog">
              <img class="bg-image" width=" " src="assets/images/status-server.svg">
              <div class="modal-dialog modal-sm" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">{{this.prerequisiteCheckLabel}}</h5>
                  </div>
                  <div class="modal-body text-left font-md ">
                    <div>
                      <div [ngClass]="webSocketSupportChecked? 'success': 'failed'">
                        <i [ngClass]="webSocketSupportChecked ? 'fa-circle-check': 'fa-circle-xmark'"
                          class="p-100 fa-solid rounded-circle"></i>
                        {{this.webSocketSupportLabel}}
                      </div>

                      <div [ngClass]="isServerCompatibleWithUI? 'success': 'failed'">
                        <i [ngClass]="isServerCompatibleWithUI ? 'fa-circle-check': 'fa-circle-xmark'"
                          class="p-100 fa-solid rounded-circle"></i>
                        {{this.serverCompatLabel}}
                      </div>

                      <div [ngClass]="isUICompatibleWithServer? 'success': 'failed'">
                        <i [ngClass]="isUICompatibleWithServer ? 'fa-circle-check': 'fa-circle-xmark'"
                          class="p-100 fa-solid rounded-circle"></i>
                        {{this.uiCompatLabel}}
                      </div>

                      <div [ngClass]="networkSpeedChecked? 'success': 'failed'">
                        <i [ngClass]="networkSpeedChecked ? 'fa-circle-check': 'fa-circle-xmark'"
                          class="p-100 fa-solid rounded-circle"></i>
                        {{this.networkSpeedCheckLabel}}
                      </div>

                      <div [ngClass]="TRSServerConnected? 'success': 'failed'">
                        <i [ngClass]="TRSServerConnected ? 'fa-circle-check': 'fa-circle-xmark'"
                          class="p-100 fa-solid rounded-circle"></i>
                        {{this.serverConnectivityLabel}}
                      </div>
                      <!-- <ng-container *ngIf="appConfig.settings.Call.Enable || appConfig.settings.defaults.FaceLoginEnabled">
                        <div [ngClass]="cameraAccessChecked? 'success': 'failed'" (click)="checkCameraAccess()">
                          <i [ngClass]="cameraAccessChecked ? 'fa-circle-check': 'fa-circle-xmark'"
                            class="p-100 fa-solid rounded-circle hover-coursor"></i>
                          {{this.cameraAccessCheckLabel}}
                          <i title="Retry" data-bs-toggle="tooltip" data-bs-placement="top" class="hover-coursor"
                            class="p-100 fa-solid rounded-circle"></i>
                        </div>
                      </ng-container> -->
                      <ng-container *ngIf="appConfig.settings.defaults.FaceLoginEnabled">
                        <div [ngClass]="cameraAccessChecked? 'success': 'failed'" (click)="checkCameraAccess()">
                          <i [ngClass]="cameraAccessChecked ? 'fa-circle-check': 'fa-circle-xmark'"
                            class="p-100 fa-solid rounded-circle hover-coursor"></i>
                          {{this.cameraAccessCheckLabel}}
                          <i title="Retry" data-bs-toggle="tooltip" data-bs-placement="top" class="hover-coursor"
                            class="p-100 fa-solid rounded-circle"></i>
                        </div>
                      </ng-container>

                      <div class="wrapper" [ngClass]="checksDone? 'd-none': ''">
                        <div class="circle"></div>
                        <div class="circle"></div>
                        <div class="circle"></div>
                        <div class="shadow"></div>
                        <div class="shadow"></div>
                        <div class="shadow"></div>
                      </div>

                      <i class="fa fa-thumbs-up wrapper" aria-hidden="true" [ngClass]="checksDone? '': 'd-none'"></i>

                      <span class="loaderTitle"> {{ progressText }}</span>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>


<div class="modal" [ngStyle]="{'display':showConnectionModal == true && WSConnected == false ? 'block' : 'none'}"
  tabindex="-1" role="dialog">
  <div class="modal-dialog modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ serverConnectionTxt }}</h5>
      </div>
      <div class="modal-body text-center">
        <p>{{this.pleaseWaitLabel}} ...</p>
      </div>
    </div>
  </div>
</div>